<template>
  <div class="forget">
    <div class="forget_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
    </div>
    <div class="forget_bottom">
      <p class="text">找回密码</p>
    </div>
    <van-form class="forget_form">
      <van-field
        class="input_tel"
        v-model="phone"
        type="tel"
        clearable
        placeholder="请输入手机号"
        :rules="[{ required: true }]"
      >
      </van-field>
      <div class="but">
        <van-button
          round
          block
          type="info"
          class="form_btn"
          @click="getCode"
          :disabled="codeFlag"
          >获取验证码</van-button
        >
      </div>
    </van-form>
    <VerifyCode
      ref="verifyCode"
      :boxShow="verifyShow"
      :phone="phone"
      @success="handleVerifySuccess"
      @close="() => (verifyShow = false)"
    />
  </div>
</template>

<script>
import VerifyCode from "./VerifyCode.vue";
import { Toast } from "vant";
export default {
  name: "forget",
  components: { VerifyCode },
  data() {
    return {
      phone: "",
      code: "",
      pattern:
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      isVerify: false,
      verifyShow: false,
    };
  },
  /* 计算属性 */
  computed: {
    /* 函数名称不能与data和methods内的名称一致 */
    codeFlag() {
      const { pattern, phone } = this;
      var reg = new RegExp(pattern);
      return !(reg.test(phone) === true);
      /* 必须return一个结果，当前结果随着内部使用的data数据的变化而动态变化 */
    },
  },
  methods: {
    to() {
      this.$router.go(-1)
    },
    async handleVerifySuccess() {
      this.isVerify = true;
      this.verifyShow = false;
      const res = await this.$apis.loginServe.getCode({
        phone: this.phone,
        adapter: "retrieve_pwd",
      });
      if (res.resultCode == "200") {
        Toast("获取成功");
        this.$router.push({
          path: "/getCodes",
          query: { phone: this.phone },
        });
      } else {
        this.isVerify = false;
        Toast(res.resultDesc);
      }
    },
    // 获取验证码
    async getCode() {
      if (!this.isVerify) this.verifyShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  background: #fff;
}
.forget {
  width: 100%;
  height: 100%;
  background: #fff;
  .forget_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
  }
  .forget_bottom {
    width: 84%;
    margin: 0 auto;
    overflow: hidden;
    .text {
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-top: 42px;
    }
  }
  .forget_form {
    width: 92%;
    margin: 16px auto;
    .input_check {
      background-color: unset;
      &::after {
        content: none !important;
      }
      .img-icon {
        width: 13px;
        height: 13px;
      }
    }

    .input_tel {
      margin-bottom: 10px;
    }
    .but {
      width: 92%;
      // margin-top: 24px;
      margin: 24px auto;
      .form_btn {
        height: 40px;
        background: #4a79f1;
        border-radius: 22px;
        .van-button__text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
